import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 py-6">
      <div className="flex flex-col items-center justify-center gap-2 text-center">
        <p className="text-sm text-muted-foreground">
          {t("footer.copyright")}
        </p>
        <p className="text-xs text-muted-foreground max-w-3xl">
          {t("footer.disclaimer")}
        </p>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
